import { Typography, Paper } from '@mui/material';
import type { VisitBlock as VisitBlockType } from './entity';
import { getContrastColor } from './colorUtils';

type VisitBlockProps = {
  visit: VisitBlockType;
  onClick?: (visitId: string) => void;
  isPreview?: boolean;
};

const VisitBlock = ({ visit, onClick, isPreview = false }: VisitBlockProps) => {
  const textColor = visit.color ? getContrastColor(visit.color) : 'white';

  return (
    <Paper
      elevation={isPreview ? 0 : 2}
      sx={{
        position: 'absolute',
        top: visit.top,
        left: 0,
        right: 0,
        height: visit.height,
        backgroundColor: visit.color || 'primary.main',
        color: textColor,
        padding: 1,
        cursor: onClick && !isPreview ? 'pointer' : 'default',
        border: isPreview ? '2px dashed' : '2px solid',
        borderColor: isPreview ? 'primary.main' : 'rgba(255, 255, 255, 0.3)',
        opacity: isPreview ? 0.7 : 0.95,
        overflow: 'hidden',
        transition: 'all 0.2s',
        boxSizing: 'border-box',
        '&:hover':
          onClick && !isPreview
            ? {
                opacity: 1,
                boxShadow: 4,
                zIndex: 100,
                transform: 'scale(1.02)',
              }
            : {},
      }}
      onClick={() => !isPreview && onClick?.(visit.id)}
    >
      <Typography variant="caption" fontWeight="bold" color={textColor} display="block">
        {visit.startTime} - {visit.endTime}
      </Typography>
      {visit.clientName && (
        <Typography variant="body2" sx={{ mt: 0.5 }} color={textColor}>
          {visit.clientName}
        </Typography>
      )}
      {visit.serviceName && (
        <Typography variant="caption" sx={{ opacity: 0.9 }} color={textColor}>
          {visit.serviceName}
        </Typography>
      )}
      {isPreview && (
        <Typography variant="caption" sx={{ fontStyle: 'italic', display: 'block', mt: 0.5 }}>
          Preview
        </Typography>
      )}
    </Paper>
  );
};

export default VisitBlock;
